<template>
  <section class="section" id="hakkimizda">
    <div class="container about-grid">
      <div class="about-photo">
        <img :src="company.logo" :alt="company.brand" />
        <h3>{{ company.brand }}</h3>
        <p>{{ t("about.cardRole") }}</p>
        <p class="about-city">{{ company.city }}</p>
        <ul>
          <li v-for="(fact, index) in facts" :key="index">{{ fact }}</li>
        </ul>
      </div>
      <div>
        <p class="eyebrow">{{ t("about.eyebrow") }}</p>
        <h2 class="section-title">{{ t("about.title") }}</h2>
        <p class="section-lead">{{ t("about.text") }}</p>
        <div class="about-points">
          <article v-for="index in 4" :key="index">
            <h3>{{ t(`about.points.${index - 1}.title`) }}</h3>
            <p>{{ t(`about.points.${index - 1}.text`) }}</p>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { company } from "@/data/company";

export default {
  name: "AboutSection",
  setup() {
    const { t, tm } = useI18n();
    const facts = computed(() => tm("about.facts") || []);
    return { t, company, facts };
  },
};
</script>
